import {Component, OnDestroy, OnInit} from '@angular/core';
import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';
import { Store, select } from '@ngrx/store';
import * as fromStore from '../../store';
import { Router } from '@angular/router';
import { DevicesService } from '../../services/devices.service';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { WindowService } from '../../services/window.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import * as fromMyfeatures from '../../my-features';
import { TinyColor } from '@ctrl/tinycolor';
import { RegionService } from 'src/app/services/region.service';
import {
  urlPath
} from "../../shareModel";

@Component({
  standalone: false,
  selector: "app-odm-login",
  templateUrl: "./odm-login.component.html",
  styleUrls: ["./odm-login.component.css"],
})
export class OdmLoginComponent implements OnInit, OnDestroy {
  public form: FormGroup;
  loginFail = false;
  isLogging = false;
  logoPath: string;
  hostName: string;
  private componentDestroyed = new Subject();
  WebVersion = environment.WebVersion;
  inputType = "password";
  showPasswordIcon: Boolean = false;
  mainColor = "#007ad9";
  selectDefaultMode = "Default";
  mainColorLight: any;
  mainColorDark: any;
  bgdefault = "#f1f3f7";
  bgheader = "#ffffff";
  mainColorText = false;
  mainColorDarkText = false;
  shareModel = {
    urlPath: urlPath
  };
  constructor(
    private fb: FormBuilder,
    private store: Store<fromStore.State>,
    private router: Router,
    private apiService: DevicesService,
    private ngxService: NgxUiLoaderService,
    private windowService: WindowService,
    private regionService: RegionService
  ) {
    
    this.store.dispatch(new fromMyfeatures.GetRegions());
    this.logoPath = this.regionService.GetLogoPath;
    this.mainColor = this.regionService.GetThemeColorCode;
    this.selectDefaultMode = this.regionService.GetSelectDefaultMode;
    this.savethem();

    this.hostName = window.location.hostname;
    this.store
      .select(fromStore.getRegions)
      .pipe(takeUntil(this.componentDestroyed))
      .subscribe((res) => {
        if (res.length > 0) {
          const region = this.windowService.getLogoRegion(res);
          if (typeof region !== "undefined" && region !== null) {
            this.regionService.SetLogoPath = region.Note;
            this.regionService.SetThemeColorCode = region.ThemeColorCode;
            this.regionService.SetSelectDefaultMode = region.Appearance;
            this.logoPath = region.Note;
            this.mainColor = region.ThemeColorCode;
            this.selectDefaultMode = region.Appearance;
          }
          // this.logoPath = (typeof region !== 'undefined' && region !== null) ? region.Note : '';
          // this.mainColor = (typeof region !== 'undefined' && region !== null) ? region.ThemeColorCode : '#007ad9';
          // this.selectDefaultMode = (typeof region !== 'undefined' && region !== null) ? region.Appearance : 'Default';

          // const logo = res.find(i => i.Domain != null && i.Domain.toLowerCase().includes(this.hostName.toLowerCase()));
          // const logoPath = (logo) ? logo.Note : null;
          // if (!!logoPath) {
          //   this.logoPath = logoPath;
          // }
          // this.mainColor = logo !== undefined ? logo.ThemeColorCode : '#007ad9';
          // this.selectDefaultMode = logo !== undefined ? logo.Appearance : 'Default';
          this.savethem();
        }
      });
  }

  savethem() {
    this.mainColorLight = new TinyColor(this.mainColor)
      .lighten(37)
      .setAlpha(0.1)
      .toString();
    this.mainColorDark = new TinyColor(this.mainColor).darken(6).toString();
    document.documentElement.style.setProperty("--bg-default", this.bgdefault);
    document.documentElement.style.setProperty("--bg-header", this.bgheader);
    document.documentElement.style.setProperty(
      "--primary-color",
      this.mainColor
    );
    document.documentElement.style.setProperty(
      "--primary-color-dark",
      this.mainColorDark
    );
    document.documentElement.style.setProperty(
      "--primary-color-light",
      this.mainColorLight
    );

    this.mainColorText = new TinyColor(this.mainColor).isLight();
    if (this.mainColorText) {
      document.documentElement.style.setProperty(
        "--primary-color-text",
        "#000000"
      );
    } else {
      document.documentElement.style.setProperty(
        "--primary-color-text",
        "#ffffff"
      );
    }

    this.mainColorDarkText = new TinyColor(this.mainColorDark).isLight();
    if (this.mainColorDarkText) {
      document.documentElement.style.setProperty(
        "--primary-color-dark-text",
        "#000000"
      );
    } else {
      document.documentElement.style.setProperty(
        "--primary-color-dark-text",
        "#ffffff"
      );
    }

    const body = document.getElementsByTagName("body")[0];

    if (this.selectDefaultMode === "Default") {
      body.classList.add("default");
      body.classList.remove("light");
      body.classList.remove("dark");
    } else if (this.selectDefaultMode === "Light") {
      body.classList.remove("default");
      body.classList.add("light");
      body.classList.remove("dark");
    } else if (this.selectDefaultMode === "Dark") {
      body.classList.remove("default");
      body.classList.remove("light");
      body.classList.add("dark");
    }
  }

  ngOnInit() {
    this.ngxService.start();
    const body = document.getElementsByTagName("body")[0];
    body.classList.add("body-login");
    body.classList.remove("body-landing");
    body.classList.remove("mobile-toggle");

    this.form = this.fb.group({
      username: [
        "",
        Validators.pattern("^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,}$"),
      ],
      password: ["", Validators.pattern("^[a-zA-Z0-9-_]{5,20}")],
      rememberMe: [true],
    });
    this.ngxService.stop();
    // this.savethem();
  }
  get username() {
    return this.form.get("username");
  }
  get password() {
    return this.form.get("password");
  }

  async login() {
    this.ngxService.start();
    this.store.dispatch(new fromStore.LoginAction({ ...this.form.value }));
    this.store.select(fromStore.getCurrentUser).subscribe(async (res) => {
      if (res.isLoading) {
        this.isLogging = true;
      } else {
        this.isLogging = false;
        this.ngxService.stop();
      }
      if (!res.isLoading && res.isLoaded && res.isLogin) {
        // 判斷是否客製化Domain,若有則跳轉
        // let EnableDomain = false;
        this.CheckCustmizeDomain(res.RegionId);
        // console.log('success');
        // alert('Success!!');
      } else if (!res.isLogin && res.isLoaded && !res.isLoading) {
        this.loginFail = true;
        // console.log('fail');
        // alert('Error!!');
      }
    });
    // this.apiService.getDeviceDetails('abcdefghijkl', 'f75d7014a776000b1d366672bcb7688f').subscribe(res => {
    //   console.log(res);
    // });
  }

  ngOnDestroy() {
    this.componentDestroyed.next(undefined);
    this.componentDestroyed.complete();
  }

  handleChange(e: any) {
    const isChecked = e.checked;
    if (isChecked) {
      this.inputType = "text";
    } else {
      this.inputType = "password";
    }
  }

  passwordChange(password: string) {
    if (password.length > 0) {
      this.showPasswordIcon = true;
    } else if (password.length === 0) {
      this.showPasswordIcon = false;
      this.inputType = "password";
    }
  }

  CheckCustmizeDomain(regionid) {
    // 判斷是否客製化Domain,若有則跳轉
    this.store
      .select(fromStore.getRegions)
      .pipe(takeUntil(this.componentDestroyed))
      .subscribe((res) => {
        res
          .filter((r) => regionid === r.Id)
          .map((item) => {
            if (item !== undefined) {
              const href = window.location.href;
              if (
                item.EnableDomain &&
                item.Domain != "" &&
                item.Domain != null &&
                !href.includes(item.Domain)
              ) {
                const regionIds = []
                this.regionService.SetRegionIds = regionIds.push(item.Id);
                this.regionService.SetEnableDomain = item.EnableDomain;
                this.regionService.SetDomainPath = item.Domain;
                this.regionService.SetLogoPath = item.Note;
                this.regionService.SetThemeColorCode = item.ThemeColorCode;
                this.regionService.SetSelectDefaultMode = item.Appearance;
                if (
                  item.Domain.includes("http://") ||
                  item.Domain.includes("https://")
                ) {
                  window.location.href = item.Domain;
                  return;
                } else {
                  window.location.href = "https://" + item.Domain;
                  return;
                }
              } else if(href.includes("/login") || href.includes("/dashboard")){
                this.router.navigate(["/index"]);
              }
            } 
            // else {
            //   this.router.navigate(["/index"]);
            // }
          });
      });
  }
}
